import styled from "styled-components";

export const Columns = styled.div`
  display: flex;
`;

export const Column = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  gap: 15px;

  & + & {
    margin-left: 15px;
  }
`;
